import { render, staticRenderFns } from "./PdpXsellModal.vue?vue&type=template&id=20484e58&scoped=true&lang=pug&"
import script from "./PdpXsellModal.vue?vue&type=script&lang=js&"
export * from "./PdpXsellModal.vue?vue&type=script&lang=js&"
import style0 from "./PdpXsellModal.vue?vue&type=style&index=0&id=20484e58&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20484e58",
  null
  
)

export default component.exports